// @module C3.ShoppingExtensions.ManufacturerPage
define('C3.PDPSerialLotFunctionality.SerialLotData.Carousel.ItemsCell'
,   [
    'tekyard_pdpseriallotfunctionality_seriallotdata_carousel_itemscell.tpl'  
    ,   'SCView'
    ,   'AjaxRequestsKiller'
    ,   'Utils'
    //,   'C3.SerialNumberPLP.SerialNumber.PLPPopup.View'
    ,   'LiveOrder.Model'
   // ,   'C3.SerialNumberPLP.AddToWishList.View'
    ,   'C3.ShoppingExtensions.LoginRegister.View'
    ,   'Profile.Model'
    ,   'Product.Model'
    ,   'ProductList.Item.Model'
    ,   'ProductList.Model'
   // ,   'ProductDetailToQuote.Confirmation.View'
    ]
, function (
    tekyard_pdpseriallotfunctionality_seriallotdata_carousel_itemscell_tpl
    
    ,   SCViewModule
    ,   AjaxRequestsKiller
    
    ,   Utils
    //,   SerialNumberPLPPopupView
    ,   LiveOrderModel
    //,   AddToWishListPLPView
    ,   LoginRegisterView
    ,   ProfileModel
    ,   ProductModel
    ,   ProductListItemModel
    ,   ProductListModel
   // ,   QuoteConfirmationView
)
{
    'use strict';

    // @class AA.SerialNumberPDP.SerialNumber.View @extends Backbone.View
    return Backbone.View.extend({

        template: tekyard_pdpseriallotfunctionality_seriallotdata_carousel_itemscell_tpl

    ,   initialize: function (options) {
            this.options = options;
            this.application = options.application;
            this.model = options.model;

        }

    /*,   events: {
            'click [data-action="plus"]': 'addQuantity',
            'click [data-action="minus"]': 'removeQuantity',
            'click [data-action="show-login-register-popup"]': 'showLoginRegisterPopup'
        }*/

    ,   bindings: {
        }

    ,   childViews: {
        }
        /*, addQuantity : function addQuantity(e){
            var self = this;
            //console.log(SC)
            var $element = jQuery(e.currentTarget);
            var quantity_input = $element.parent().find('.item-quantity-value');
            var button_minus = $element.parent().find('.minus-button');
            var find_title_ele = $element.closest('.e2');
            var cart = this.application.getComponent('Cart');
            var lines=[];

            var selectedSerialNumber = $element.attr('data-serial');
            var selectedSerialImg = $element.attr('data-img');

            var itemQtyInCurrentOrder = 0;

            var liveOrder = LiveOrderModel.getInstance();
            //console.log(self.model.get('_id'))

            var internalID=quantity_input.attr("data-id");

            //console.log(selectedSerialImg)
            
            var lineData=liveOrder.get('lines').filter(function(line)
            {   
                var line_options = line.get('options')
                ,   findOptionId = ''
                if(line_options.length > 0)
                {
                   var line_options_models =  line_options.models              
                   ,   targetId = "custcol_inventory_number";

                   if(line_options_models.length > 0)
                   {
                       var filteredOptions = line_options_models.find(option => option.get('cartOptionId') === targetId)
                       ,    getOptionValue = filteredOptions.get('value')
                       if(getOptionValue)
                       findOptionId = getOptionValue.internalid;
                   }
                }
                return findOptionId == self.model.get('inventorynumber');

                //return line.get('item').get('internalid') == internalID;
            });
            
            //console.log(lineData)

            if(lineData.length > 0)
            {
            var lineQuantity=lineData[0].get('quantity');
            itemQtyInCurrentOrder = lineQuantity;
            }

            var elementParent = $element.parent('.plus-icon');      
            //console.log(elementParent)

            var trashCane = $element.parent().find('.product-trash-tray');
            
           // console.log(find_title_ele)
            quantity_input.show();
           // button_minus.show();

            var parentEle = $element.parent('.plus-icon');
            if(!(parentEle.hasClass('expand-plus-icon')))
            parentEle.addClass('expand-plus-icon');

            find_title_ele.addClass('newly-added-css');
            
            var old_value = quantity_input.text();

             if(elementParent.hasClass('add-to-cart-buttons-opened'))
             {
            var new_val = parseFloat(old_value) == 0 ? 1 : parseFloat(old_value)+1; 
            quantity_input.text(new_val);
            }
            
            var quantity = quantity_input.text();
            var internalID=quantity_input.attr("data-internalid");


            if(quantity == 1)
            {
                trashCane.show();
                button_minus.hide();
                quantity_input.css('text-align','left');
                
            }
            else    
            {
                 button_minus.show();
                trashCane.hide();
                quantity_input.css('text-align','center');
            }

           // console.log(quantity)
            
            if(quantity>0)
            {
                if(itemQtyInCurrentOrder && !(elementParent.hasClass('add-to-cart-buttons-opened')))
                {
                    $element.text('+');
                    $element.removeClass('plus-button-additional');

                    elementParent.addClass('add-to-cart-buttons-opened');
                    elementParent.removeClass('plus-icon-additional');

                }else
                {

                    SC.loadingIndicatorShow();
                    cart.addLine({
                    line: {
                            quantity: parseFloat(1),
                            item: {internalid: parseFloat(internalID)},
                            options:[{
                            "value":{"label": selectedSerialNumber,"internalid": selectedSerialNumber},
                            "cartOptionId": "custcol_inventory_number",
                            "label": "Serial"
                            },{
                            "value":{"label": selectedSerialImg,"internalid": selectedSerialImg},
                            "cartOptionId": "custcol_inventory_number_image",
                            "label": "SerialImage"
                            }]
                        }
                    }).done(function(e) {
                        SC.loadingIndicatorHide();
                        if(!Utils.isPhoneDevice())
                        jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");

                        elementParent.addClass('add-to-cart-buttons-opened');   
                    });
                    
                   
                }
            }
        }

       ,    showLoginRegisterPopup : function showLoginRegisterPopup(e) {
                e.stopPropagation();
                e.preventDefault();
                
                var Layout = this.application.getComponent('Layout');
                //console.log(Layout)

                var view = new LoginRegisterView({
                    application: Layout.application
                });

                if (view)
                Layout.showContent(view, {showInModal: true});
            }

        ,  removeQuantity : function removeQuantity(e){
            const $element = jQuery(e.currentTarget);
            const quantity_input = $element.parent().find('.item-quantity-value');
            const find_title_ele = $element.closest('.e2');
            const old_value = quantity_input.text();
            const cart = this.application.getComponent('Cart');
            var lines=[];

            if(old_value==1 )
            {
                var parentEle = $element.parent('.plus-icon');
                if(parentEle.hasClass('expand-plus-icon'))
                parentEle.removeClass('expand-plus-icon');

             if(parentEle.hasClass('add-to-cart-buttons-opened'))
                parentEle.removeClass('add-to-cart-buttons-opened');

                find_title_ele.removeClass('newly-added-css');
                let new_val = parseFloat(old_value) - 1;
               
                if(new_val == 0)
                    quantity_input.text(1);
                else
                    quantity_input.text(new_val);
                
                $element.attr("style","display:none !important;");
                quantity_input.hide();
            }
            else if(old_value>1 ){
                let new_val = parseFloat(old_value) - 1;
                quantity_input.text(new_val);

                if(old_value == 2)
                {
                    var trashCane = $element.parent().find('.product-trash-tray');
                    var button_minus = $element.parent().find('.minus-button');
                    //console.log(button_minus)
                    button_minus.attr("style","display:none !important;");
                    trashCane.show();
                    quantity_input.css('text-align','left');
                    
                }
            }
            var internalID=quantity_input.attr("data-id");
            
            var liveOrder = LiveOrderModel.getInstance();
            
            var self = this;
            var lineData=liveOrder.get('lines').filter(function(line)
            {   
                var line_options = line.get('options')
                ,   findOptionId = ''
                if(line_options.length > 0)
                {
                   var line_options_models =  line_options.models              
                   ,   targetId = "custcol_inventory_number";

                   if(line_options_models.length > 0)
                   {
                       var filteredOptions = line_options_models.find(option => option.get('cartOptionId') === targetId)
                       ,    getOptionValue = filteredOptions.get('value')
                       if(getOptionValue)
                       findOptionId = getOptionValue.internalid;
                    }
                }
                return findOptionId == self.model.get('inventorynumber');
            });
            var lineQuantity=lineData[0].get('quantity');
            
            if(lineQuantity==1)
                liveOrder.removeLine(
                lineData[0].set('quantity',parseFloat(lineQuantity)-1));
            else
            {
                liveOrder.updateLine(
                lineData[0].set('quantity',parseFloat(lineQuantity)-1));
                setTimeout(function(){
                    if(!Utils.isPhoneDevice())
                        jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");
                }, 1000);
            }

        }*/
  

        //@method getContext @return AA.SerialNumberPDP.SerialNumber.View.Context
    ,   getContext: function getContext()
        {
            //console.log(this.model)
           
            return {
                
            };
        }
    });
});
